import { AxiosResponse } from 'axios';
import { useHttpClient } from '../components/infra/httpClient.component';
import { FileResponse } from '../components/interfaces/FileResponse';

export interface Repertoire {
    sheets: FileResponse[]
}

export const useRepertoireService = () => {
    const httpClient = useHttpClient();
    const BaseUrl = 'repertoire';

    const get = (): Promise<AxiosResponse<Repertoire, any>> => {
        return httpClient.get(BaseUrl);
    };

    const add = (data: FileResponse): Promise<AxiosResponse<any, any>> => {
        return httpClient.patch(`${BaseUrl}`, data);
    }

    const up = (data: FileResponse): Promise<AxiosResponse<any, any>> => {
        return httpClient.patch(`${BaseUrl}/up`, data);
    }

    const first = (data: FileResponse): Promise < AxiosResponse < any, any >> => {
    return httpClient.patch(`${BaseUrl}/first`, data);
}

    const down = (data: FileResponse): Promise < AxiosResponse < any, any >> => {
    return httpClient.patch(`${BaseUrl}/down`, data);
}

    const last = (data: FileResponse): Promise < AxiosResponse < any, any >> => {
    return httpClient.patch(`${BaseUrl}/last`, data);
}

    const remove = (data: FileResponse): Promise < AxiosResponse < any, any >> => {
    return httpClient.patch(`${BaseUrl}/remove`, data);
}

    const clear = (): Promise < AxiosResponse < any, any >> => {
    return httpClient.post(`${BaseUrl}/clear`);
}

    const download = (): Promise < AxiosResponse < any, any >> => {
    return httpClient.post(`${BaseUrl}/download`);
}

return { get, add, up, first, down, last, remove, clear, download };

}